import { useState } from "react";
import { db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import LanguageToggle from "./LanguageToggle";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const q = query(
        collection(db, "clients"),
        where("formDataPurchase.email", "==", email)
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        const clientDocId = docSnap.id;
        const data = docSnap.data();
        const formDataPurchase = data.formDataPurchase || {};

        if (formDataPurchase.password === password) {
          // Store only what's needed
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("clientDocId", clientDocId);
          localStorage.setItem(
            "clientInfo",
            JSON.stringify({
              firstName: formDataPurchase.firstName || "",
              lastName: formDataPurchase.lastName || "",
              email: formDataPurchase.email || "",
              phone: formDataPurchase.phone || "",
            })
          );

          setMessage("✅ Redirigiendo al panel...");
          setIsSuccess(true);
          setTimeout(() => {
            window.location.href = "/es/dashboard";
          }, 1500);
        } else {
          setMessage("❌ Correo electrónico o contraseña incorrectos.");
        }
      } else {
        setMessage("❌ Correo electrónico o contraseña incorrectos..");
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage("❌ Ocurrió un error. Por favor, intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      style={{
        padding: "2rem",
        fontFamily: "sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
        textAlign: "center",
        position: "relative",
      }}
    >
      <div style={{ position: "absolute", top: 16, right: 16, zIndex: 10 }}>
        <LanguageToggle />
      </div>
      <div
        style={{
          maxWidth: "400px",
          margin: "0 auto",
          padding: "3.5rem 2rem 2rem 2rem",
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          position: "relative",
          minHeight: "300px",
        }}
      >
        <a
          href="/admin-login"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          <img
            src="/assets/HMBHOUSE.png"
            alt="Home Mortgage Logo"
            style={{
              width: "110px",
              height: "110px",
              objectFit: "contain",
            }}
          />
        </a>
        <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
          Acceder a Cuenta
        </h1>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => {
              const safeValue = e.target.value.replace(/<[^>]*>?/gm, "").trim();
              setEmail(safeValue);
            }}
            required
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            title="Ingrese un correo electrónico válido"
          />
          <input
            type="password"
            placeholder="Contraseña "
            value={password}
            onChange={(e) => {
              const safeValue = e.target.value.replace(
                /[^a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g,
                ""
              );
              setPassword(safeValue);
            }}
            required
            pattern=".{6,}"
            title="La contraseña debe tener al menos 6 caracteres"
          />
          <button type="submit" disabled={loading}>
            {loading ? "Accediendo..." : "Iniciar "}
          </button>
        </form>
        {message && (
          <p
            style={{
              marginTop: "1rem",
              color: isSuccess ? "green" : "red",
            }}
          >
            {message}
          </p>
        )}
        <p style={{ marginTop: "1.5rem" }}>
          ¿No tienes cuenta? <a href="/">Regístrate</a>
        </p>
      </div>
    </main>
  );
}
